
export const positive_number = (value): string => {
    return (value && value > 0) ? undefined : "This should be greater than zero.";
};

export default positive_number;


// WEBPACK FOOTER //
// ./app/client/_widgets/form/validators.ts